<template>
  <section v-if="releaseCards.length" class="ni-section ni-release" id="qd-release">
    <div class="ni-container">
      <SectionHeader
        variant="dark"
        :subtitle="t('newIndex.sections.release.subtitle')"
        more-href="/publish"
      >
        <template #title>
          <span class="ni-section-header__title-mark">
            {{ t('newIndex.sections.release.title') }}
          </span>
        </template>
      </SectionHeader>

      <div class="ni-release__grid">
        <a
          v-for="card in releaseCards"
          :key="card.id"
          :id="`release-card-${card.id}`"
          class="ni-release__card"
          :href="card.href"
          :title="card.title"
        >
          <div class="ni-release__media">
            <img :src="card.imageUrl" :alt="card.title" />
          </div>

          <div class="ni-release__footer">
            <p class="ni-release__label">{{ card.title }}</p>
            <span class="ni-release__date">{{ card.date }}</span>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import SectionHeader from './shared/SectionHeader.vue';

defineProps({
  releaseCards: {
    type: Array,
    default: () => [],
  },
});

const { t } = useI18n();
</script>
